import { faBackspace } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./InputSelect.module.scss";

type InputSelectProps = {
  options: (number | "back" | "complete")[];
  currentPosition: number;
  numberOfSteps: number;
};

export default function InputSelect({
  options,
  currentPosition,
  numberOfSteps,
}: InputSelectProps) {
  return (
    <>
      <div className={styles.inputSelect}>
        <div
          style={{
            transform: `translate(-${(100 / numberOfSteps) * currentPosition}%, -50%)`,
          }}
          className={styles.slideRow}
        >
          {options.map((option, i) => (
            <div
              className={`${styles.item}  ${currentPosition === i ? styles.active : null}`}
              key={i}
            >
              {!isNaN(option as number) ? (
                <p>{option}</p>
              ) : (
                <>
                  {option === "back" && <FontAwesomeIcon icon={faBackspace} />}
                  {option === "complete" && <FontAwesomeIcon icon={faCheck} />}
                </>
              )}
            </div>
          ))}
        </div>
        <div className={styles.lens}></div>
      </div>
    </>
  );
}
